import { Grid, TextField, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { Autocomplete } from "@mui/material";
import React from "react";
import { useEffect } from "react";

import { usePostalCodeFields } from "./hooks/usePostalCodeFields";
import { useStyles } from "./styles";

const PostalCodeFields = ({
  data,
  setData,
  handleChange,
  zipHelper,
  zipError,
  cityHelper,
  cityError,
  isEditing,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { calcAddress, calcPostalCode, calcAddressSuggestions } =
    usePostalCodeFields();

  useEffect(() => {
    setData({ ...data, zipcode: data?.zipcode });
    if (data?.zipcode?.length > 0) {
      let suggestion = calcAddress(data?.zipcode, data?.city);
      if (suggestion === data?.zipcode) return;
      if (typeof suggestion === "undefined") {
        setData({ ...data, city: "" });
        return;
      } else {
        setData({ ...data, city: suggestion });
      }
    }
  }, [data?.zipcode]);

  useEffect(() => {
    setData({ ...data, city: data?.city });
    if (data?.city?.length > 0) {
      let suggestion = calcPostalCode(data?.city, data?.zipcode);
      if (suggestion === data?.city) return;
      if (typeof suggestion === "undefined") {
        setData({ ...data, zipcode: "" });
        return;
      } else {
        setData({ ...data, zipcode: suggestion });
      }
    }
  }, [data?.city]);

  return (
    <Grid container spacing={2} xs={12} style={{ marginLeft: "0" }}>
      <Grid container item xs={12} md={6}>
        <Grid item xs={12}>
          <Typography variant="body1">Irányítószám</Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            disabled={!isEditing}
            variant="outlined"
            fullWidth
            id="zip"
            name="zip"
            required
            margin="normal"
            placeholder="0000"
            value={data?.zipcode}
            key="postal_code_field"
            onChange={(e) => {
              // handleChange(e);
              setData({ ...data, zipcode: e.target.value });
            }}
            error={zipHelper && Boolean(zipError)}
            helperText={zipHelper && zipError}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={12}>
          <Typography>Település</Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            disabled={!isEditing}
            variant="outlined"
            id="city"
            required
            margin="normal"
            name="city"
            value={data?.city}
            fullWidth
            key="address_field"
            onChange={(e) => {
              // handleChange(e);
              setData({ ...data, city: e.target.value });
            }}
            error={cityHelper && Boolean(cityError)}
            helperText={cityHelper && cityError}
          />
        </Grid>
        {/* <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={calcAddressSuggestions(data?.city)}
          inputValue={data?.city}
          onChange={(e) =>
            setData({
              ...data,
              city: e.target.innerHTML.includes("<")
                ? ""
                : e.target.innerHTML,
            })
          }
          renderInput={(params) => (
            <TextField
              id="city"
              required
              name="city"
              value={data?.city}
              className={classes.input}
              {...params}
              key="address_field"
              onChange={(e) => {
                handleChange(e);
                setData({ ...data, city: e.target.value });
              }}
              error={cityHelper && Boolean(cityError)}
              helperText={cityHelper && cityError}
            />
          )}
        /> */}
      </Grid>
    </Grid>
  );
};

export default PostalCodeFields;
